import PageImage1 from '../Images/Press/2026-01-28.jpeg'

import Header from '../components/header'
import Footer from '../components/footer'
import NewsLetter from '../components/newsletter'

import { HelmetProvider } from 'react-helmet-async';

export default function Press() {
    return (
        <div style={{ backgroundColor: '#FFFDF4' }}>
            <HelmetProvider>
                <title>Press</title>
                <meta name="" />
                <link rel="canonical" href="https://sursaathi.in/press" />
            </HelmetProvider>
            <Header />
            <div className="MainGallery">
                <div className="MainGallery-col">
                    <img src={PageImage1} alr="Global Times Sur Saathi Press Cover"/>
                </div>
                <div className="MainGallery-col">
                </div>
                <div className="MainGallery-col">
                </div>
            </div>
            <div>
                <div className="Newsletter-Section">
                    <h2>
                        Stay in Tune with Music Education
                    </h2>
                    <p>
                        Get updates on upcoming events, workshops, and ways you can support music education for children across India — from free music education sessions to chances to donate instruments.
                    </p>
                </div>
            </div>
            <NewsLetter />
            <Footer />
        </div>
    );
}
